import { render, staticRenderFns } from "./FormType5.vue?vue&type=template&id=b68ce346&"
import script from "./FormType5.vue?vue&type=script&lang=js&"
export * from "./FormType5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports